import { register } from "../../../JavaScript/Utils";

type CompanyCode = Array<[string, string]>;

export const CompanyCodesLufthansa = async (el: HTMLElement) => {
  const divForContainer: HTMLElement = el.querySelector(
    ".comp-company-code-lufthansa--card-generator"
  );
  const searchInput: HTMLInputElement = el.querySelector("#subcompanyInput");
  const suggestionsList: HTMLElement = el.querySelector(
    ".comp-company-code-lufthansa--suggestions"
  );
  const compnayCode: HTMLElement = el.querySelector("#company-code");
  const form: HTMLFormElement = el.querySelector("form");
  const chevronIcon: HTMLAnchorElement = el.querySelector(
    ".comp-company-code-lufthansa--input-container"
  );

  const jsonFile = divForContainer.dataset.json;
  const response = await fetch(jsonFile);
  if (!response.ok) {
    const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }
  let companyCodes: CompanyCode = await response.json();
  companyCodes = companyCodes.sort(function(a, b) {
    return a[1].localeCompare(b[1]);
  })

  const autoSuggestion = (inputValue: string) => {
    const searchTerm = inputValue.toLowerCase();
    suggestionsList.innerHTML = "";

    const matchedItems = companyCodes
      .filter(([code, name]) => name.toLowerCase().includes(searchTerm))
      .map(([code, name]) => ({ code, name }));
    suggestionsList.style.display = "block";
    matchedItems.forEach(({ code, name }) => {
      const listItem = document.createElement("li");
      listItem.textContent = name;
      listItem.addEventListener("click", () => {
        searchInput.value = name;
        compnayCode.innerHTML = code;
        suggestionsList.style.display = "none";
      });
      suggestionsList.appendChild(listItem);
    });
  };

  searchInput.addEventListener("input", (event) => {
    autoSuggestion((event.target as HTMLInputElement).value);
    chevronIcon.classList.add("is-active");
  });
  searchInput.addEventListener("blur", () => {
    setTimeout(() => {
      suggestionsList.style.display = "none";
    }, 200);
  });

  form.addEventListener("reset", function () {
    compnayCode.innerHTML = "****";
    suggestionsList.scrollTop = 0;
  });

  chevronIcon.addEventListener("click", () => {
    if (suggestionsList.style.display == "block") {
      chevronIcon.classList.remove("is-active");
      suggestionsList.style.display = "none";
    } else {
      autoSuggestion("");
      chevronIcon.classList.add("is-active");
      suggestionsList.scrollTop = 0;
    }
  });
};

register("CompanyCodesLufthansa", CompanyCodesLufthansa);
